module.exports = __webpack_public_path__ + "img/meditation.c794721b.png";